"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _themeContants = require("../../../constants/themeContants");

var selectThemeProps = {
  iconComponent: {
    name: "COMPONENT_SELECT_CARET_ICON",
    description: "Select icon",
    type: _themeContants.themePropTypes.component
  },
  closeComponent: {
    name: "COMPONENT_SELECT_CLOSE_ICON",
    description: "Close icon",
    type: _themeContants.themePropTypes.component
  },
  iconClose: {
    name: "COMPONENT_SELECT_CLOSE_ICON_STYLE",
    description: "Icon close style",
    type: _themeContants.themePropTypes.style
  },
  defaultOptionWrapper: {
    name: "SELECT_DEFAULT_OPTION_ELEMENT_WRAPPER",
    description: "Default option wrapper style",
    type: _themeContants.themePropTypes.style
  },
  selectWrapper: {
    name: "SELECT_WRAPPER",
    description: "Icon close style",
    type: _themeContants.themePropTypes.style
  },
  selectedWrapper: {
    name: "SELECTED_WRAPPER",
    description: "Icon close style",
    type: _themeContants.themePropTypes.style
  },
  iconButton: {
    name: "SELECT_ICON_BUTTON",
    description: "Icon close style",
    type: _themeContants.themePropTypes.style
  },
  optionContainer: {
    name: "SELECT_DEFAULT_OPTION",
    description: "Select default Button-style",
    type: _themeContants.themePropTypes.style
  }
};
var _default = selectThemeProps;
exports["default"] = _default;